export default "__VITE_ASSET__FpANcX9K__"